// IMAGE ZOOM EDITORS, A , LINK
// -----------------------------------
import * as $ from 'jquery';
import '../../../../vendors/lightGallery/dist/js/lightgallery-all.min';

(function (window, document, $) {

    var execute = function (element) {


            $(element).find('img.zoom').each(function () {
                var img;
                img = $(this).attr('src');
                $(this).wrap(`<div class='image-zoom' style='transition: transform .2s'><a href='${img}'></a></div>`)
                    .css('cursor', 'zoom-in')
                    .parent().parent()
                    .hover(function () {
                        $(this).css('transform', 'scale(1.05)');
                    }, function () {
                        $(this).css('transform', 'scale(1)');
                    }).lightGallery({download: false});
            });

    };


    /****** EVENTS RAILS READY BY ESTUDIOLIVER *******/

    $(function () {
        execute(document.body);  // ready form document
    });

    $(document).on("modalDialogOverlay.shown.bs.modal modalDialog.shown.bs.modal confirmdialog.shown.bs.modal modal.loadedform", function (e, modal) {
        execute(modal);  // showDialog & confirmDialog & ajaxform
    });


})(window, document, $);
